import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import ToolForm from "components/tools/ToolForm";
import { updateTool } from "graphql/mutations";
import { getTool } from "graphql/queries";

const ToolUpdateForm = ({ toolId, onSuccess }) => {
  const navigate = useNavigate();
  const [tool, setTool] = useState();

  async function onSubmit(valuesParam) {
    try {
      const { name, location, description, companyID, technicianID } =
        valuesParam;

      await API.graphql({
        query: updateTool.replaceAll("__typename", ""),
        variables: {
          input: {
            id: toolId,
            name,
            location,
            description,
            companyID,
            technicianID: technicianID || null,
          },
        },
      });

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
      else navigate("/tools");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  async function fetchTool(id) {
    try {
      const toolData = await API.graphql(graphqlOperation(getTool, { id }));
      const toolItem = toolData.data.getTool;
      if (!toolItem) {
        toast.error(strings.responses.errorFetch);
        navigate("/tools");
        return;
      }
      setTool({
        ...toolItem,
      });
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchTool(toolId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toolId]);

  if (!tool) return <Loader />;

  return (
    <div>
      <ToolForm onSubmit={onSubmit} type="update" initialValues={tool} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Herramienta",
    successUpdated: "Herramienta actualizado con éxito",
    responses: {
      errorFetch: "Error al consultar la herramienta",
    },
  },
});

export default ToolUpdateForm;
